import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const EmailStyleApi = {
    get: (options?: BaseApiQueryOptions) => apiQueryOptions(['emailStyle', 'get'], (api) => api.emailStyle.get(), options),
    set: (options?: BaseApiMutationOptions<ApiClient['emailStyle']['set']>) => apiMutationOptions((api) => api.emailStyle.set, options),
    uploadHeaderImage: (options?: BaseApiMutationOptions<ApiClient['emailStyle']['uploadHeaderImage']>) =>
        apiMutationOptions((api) => api.emailStyle.uploadHeaderImage, options),
    deleteHeaderImage: (options?: BaseApiMutationOptions<ApiClient['emailStyle']['deleteHeaderImage']>) =>
        apiMutationOptions((api) => api.emailStyle.deleteHeaderImage, options)
};
